module.exports = __webpack_public_path__ + "static/media/logo1.6035e500.png";